export default {
  computed: {
    clientId() {
      return this.$route.params.clientId;
    },
  },
};
